import React, { useEffect } from 'react';

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

const contentStyle = (width = 420) => ({
  background: 'var(--card-bg)',
  border: '1px solid var(--border-color)',
  borderRadius: '8px',
  padding: '1.5rem',
  maxWidth: width,
  width: '90%',
  maxHeight: '90vh',
  overflow: 'auto',
});

const titleStyle = {
  margin: '0 0 1rem',
  fontSize: '1.1rem',
  fontWeight: 600,
  color: 'var(--text-primary)',
};

export default function N8nModal({ title, children, onClose, width }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return (
    <div
      style={overlayStyle}
      onClick={(e) => e.target === e.currentTarget && onClose?.()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="n8n-modal-title"
    >
      <div style={contentStyle(width)} onClick={(e) => e.stopPropagation()}>
        {title && (
          <h2 id="n8n-modal-title" style={titleStyle}>
            {title}
          </h2>
        )}
        {children}
      </div>
    </div>
  );
}
